import WireWidgetCard from "./WireWidgetCard";
import { maskAccountNumber } from "../wireUtils";

/**
 * Bank details entry point. The same account serves manual and automatic
 * pay-outs; editing is locked while any pay-out request is active.
 */
const BankDetailsWidget = ({ bankAccount, payoutActive, onOpen }) => {
  if (!bankAccount) {
    return (
      <WireWidgetCard
        title="Bank details"
        actions={[{ id: "bank-details-set", label: "Set bank details", onClick: onOpen }]}
      >
        <div className="widget-line">
          <span className="widget-value">No bank account added</span>
        </div>
        <div className="widget-muted">
          Add bank details to receive manual and automatic payouts.
        </div>
      </WireWidgetCard>
    );
  }

  const beneficiary = bankAccount.beneficiaryName || bankAccount.accountHolder || "";
  const masked = maskAccountNumber(bankAccount.accountNumber);
  const subline = [masked, beneficiary].filter(Boolean).join(" · ");
  const note = payoutActive
    ? "Changes are locked while a payout is active."
    : "Your payouts are sent to this bank account.";

  return (
    <WireWidgetCard
      title="Bank details"
      actions={[{ id: "bank-details-view", label: "View bank details", onClick: onOpen }]}
    >
      <div className="widget-line">
        <span className="widget-value">{bankAccount.bankName || "Bank account"}</span>
      </div>
      {subline && <div className="widget-muted">{subline}</div>}
      <div className="widget-muted">{note}</div>
    </WireWidgetCard>
  );
};

export default BankDetailsWidget;
